import styled from "styled-components";
import {Button} from "antd";

export const FixedButtonWrapper = styled.div`
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 1002;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    width: 64px !important;
    height: 64px !important;

    color: #fff;
    outline: none;
    border: none;
    border-radius: 50%;
    box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
`;

export const FixedButton = styled(Button)`
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: #25d366;
    width: 50px !important;
    height: 50px !important;
    padding-top: 5px;
    color: #fff;
    outline: none;
    border: none;
    &:hover,
    &:focus,
    &:active {
        background-color: #25d366;
        color: #fff;
        outline: none;
    }
`;
